export const GET_CHATMETERLOCATIONS_API_REQUEST = "GET_LMDEPARTMENTS_API_REQUEST";
export const GET_CHATMETERLOCATIONS_API_SUCCESS = "GET_CHATMETERLOCATIONS_API_SUCCESS";
export const GET_CHATMETERLOCATIONS_API_ERROR = "GET_CHATMETERLOCATIONS_API_ERROR";

export const GET_CHATMETERDEACTIVELOCATIONS_API_REQUEST = "GET_CHATMETERDEACTIVELOCATIONS_API_REQUEST";
export const GET_CHATMETERDEACTIVELOCATIONS_API_SUCCESS = "GET_CHATMETERDEACTIVELOCATIONS_API_SUCCESS";
export const GET_CHATMETERDEACTIVELOCATIONS_API_ERROR = "GET_CHATMETERDEACTIVELOCATIONS_API_ERROR";

export const GET_CHATMETERACCOUNTS_API_REQUEST = "GET_CHATMETERACCOUNTS_API_REQUEST";
export const GET_CHATMETERACCOUNTS_API_SUCCESS = "GET_CHATMETERACCOUNTS_API_SUCCESS";
export const GET_CHATMETERACCOUNTS_API_ERROR = "GET_CHATMETERACCOUNTS_API_ERROR";

export const ADD_CHATMETERACCOUNT_API_REQUEST = "ADD_CHATMETERACCOUNT_API_REQUEST";
export const ADD_CHATMETERACCOUNT_API_SUCCESS = "ADD_CHATMETERACCOUNT_API_SUCCESS";
export const ADD_CHATMETERACCOUNT_API_ERROR = "ADD_CHATMETERACCOUNT_API_ERROR";
